/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable indent */
/* eslint-disable no-restricted-globals */
import React, { useState, useCallback, useEffect, useRef } from 'react';
import { HiDownload } from 'react-icons/hi';
import { MdBlock } from 'react-icons/md';
import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';
import * as Yup from 'yup';
import { AiOutlineFileDone } from 'react-icons/ai';
import { useHistory } from 'react-router-dom';
import Button from '../../components/Button';
import LoaderModal from '../../components/LoaderModal';
import ModalDuplicateLetter from './components/ModalDuplicateLetter';
import TicketService from '../../services/ticket';
import DownLoadFile from '../../utils/DownLoadFile';
import { ArrayFilters } from '../../interfaces/ticket';
import BloquedTable from './components/BloquedTable';
import Input from '../../components/Input';
import Modal from '../../components/Modal';
import AuthService from '../../services/auth';
import getValidationErrors from '../../utils/getValidationErrors';
import {
  Row,
  Column,
  IconContainer,
  InfoContainer,
  InfoItem,
} from '../../styles/components';

import {
  Container,
  Title,
  ButtonsContainer,
  FormWrapper,
  Block,
  ModalContent,
  LinkModal,
} from './styles';
import { useToast } from '../../hooks/toast';

const BloquedNotDuplicated: React.FC = () => {
  const services = { TicketService: new TicketService() };
  const [loading, setLoading] = useState<boolean>(false);
  const [loadingModal, setLoadingModal] = useState<boolean>(false);
  const [page, setpage] = useState<number>(1);
  const [perPage, setPerPage] = useState<number>(30);
  const [totalRows, setTotalRows] = useState<number>(0);
  const [bloqued, setBloqued] = useState<any>(null);
  const { push } = useHistory();
  const authService = { AuthService: new AuthService() };
  const [showDuplicateLetter, setShowDuplicateLetter] =
    useState<boolean>(false);
  const formRefRelatorio = useRef<FormHandles>(null);
  const [titular, setTitular] = useState<any>();
  const [tipoRelatorio, setTipoRelatorio] = useState<string>('');
  const { addToast } = useToast();
  const [modalRelatorio, setModalRelatorio] = useState<boolean>(false);
  const [cardNumber, setCardNumber] = useState<string>('');
  const [responsible, setResponsible] = useState<string>('');
  const [dataBloqueio, setDataBloqueio] = useState<string>('');
  const [filters, setFilters] = useState<ArrayFilters>({
    filters: [
      { page },
      { quantity: perPage },
      { no_duplicate: 'True' },
      { 'code-type-util': '2' },
    ],
  });

  const getTitular = useCallback(async () => {
    try {
      setLoading(true);
      const response = await authService.AuthService.getTitular();
      await setTitular(response.data.DadosDoTitular);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.error(err);
    }
  }, []);

  const schemaRelatorio = Yup.object().shape({
    email: Yup.string().required('É necessário informar o email'),
  });

  const getBloqued = useCallback(async () => {
    try {
      setLoading(true);
      const response = await services.TicketService.getTicketBlocked(filters);
      setBloqued(response.data);
      setPerPage(response.data.ListaDeCartoesBloqSemSegViaQuantidade);
      setTotalRows(response.data.ListaDeCartoesBloqSemSegViaTotal);
      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  }, [filters]);

  const handleChangePerPage = useCallback(
    async (newPage: number) => {
      setpage(newPage);
      setFilters({ filters: [...filters.filters, { page: newPage }] });
    },
    [filters],
  );

  const handleChangeRowsPerPage = useCallback(
    async (newPerPage: number, OldPerPage: number) => {
      setPerPage(newPerPage);
      setpage(OldPerPage);
      setFilters({
        filters: [
          ...filters.filters,
          { page: OldPerPage },
          { quantity: newPerPage },
        ],
      });
    },
    [filters],
  );

  function relatorio() {
    push('/agendado');
  }

  const handleReportAsync = useCallback(
    async (type: string, Email: string) => {
      try {
        setLoadingModal(true);
        const reportFilters = {
          filters: [
            {
              'file-type': type === 'csv' ? 'C' : 'P',
              email: Email,
              user: titular.IdentificadorTitular,
              async: true,
            },
          ],
        };
        await services.TicketService.getTicketBlockedReport(
          reportFilters,
          type,
        );

        addToast({
          type: 'success',
          title: 'Relatório exportado com sucesso, por favor, aguarde.',
        });

        setLoadingModal(false);
      } catch (err: any) {
        setLoadingModal(false);

        addToast({
          type: 'error',
          title: `${err.response.data.message} ${err.response.data.sub_message}`,
        });
        const { ...error } = err;
        console.error(error);
      }
    },
    [titular],
  );

  const handleSubmitRelatorio = useCallback(
    async (data: any) => {
      try {
        formRefRelatorio.current?.setErrors({});
        await schemaRelatorio.validate(data, {
          abortEarly: false,
        });
        setLoading(true);
        await handleReportAsync(tipoRelatorio, data.email);
        setLoading(false);
      } catch (err: any) {
        setLoading(false);
        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);
          formRefRelatorio.current?.setErrors(errors);
        }
      }
    },
    [tipoRelatorio, titular],
  );

  useEffect(() => {
    getBloqued();
    getTitular();
  }, [filters]);

  const handleReport = useCallback(async (type: string) => {
    const reportFilters = {
      filters: [{ 'file-type': type === 'csv' ? 'C' : 'P' }],
    };
    try {
      setLoadingModal(true);
      const response = await services.TicketService.getTicketBlockedReport(
        reportFilters,
        type,
      );
      DownLoadFile(response.data, `BloqueadosSemSegundaVia.${type}`);
      setLoadingModal(false);
    } catch (err: any) {
      setLoadingModal(false);
      const { ...error } = err;
      console.error(error);
    }
  }, []);

  const RelatorioAgendados = useCallback(async (type: string) => {
    const reportFilters = {
      filters: [{ 'file-type': type === 'csv' ? 'C' : 'P' }],
    };
    try {
      const response = await services.TicketService.getTicketBlockedReport(
        reportFilters,
        type,
      );
    } catch (err: any) {
      const { ...error } = err;
      console.error(error);
    }
  }, []);

  const openModalCSV = useCallback(() => {
    setModalRelatorio(true);
    setTipoRelatorio('csv');
    RelatorioAgendados('csv');
  }, []);

  const openModalPDF = useCallback(() => {
    setModalRelatorio(true);
    setTipoRelatorio('pdf');
    RelatorioAgendados('pdf');
  }, []);

  // const handleClearFilters = useCallback(() => {
  //   setFilters({
  //     filters: [{ page }, { quantity: perPage }],
  //   });
  // }, []);

  // const handleNumberCardFilter = useCallback(
  //   data => {
  //     const isOnlyNumber = !isNaN(data.search);

  //     setFilters({
  //       filters: [
  //         ...filters.filters,
  //         isOnlyNumber
  //           ? {
  //               'code-ident-ext': data.search,
  //             }
  //           : {
  //               'name-employee': data.search,
  //             },
  //       ],
  //     });
  //   },
  //   [filters],
  // );

  const handleShowModalDuplicateLetter = useCallback(
    (codCard: string, dataBloqueio: string) => {
      setResponsible('');
      setCardNumber(codCard);
      setDataBloqueio(dataBloqueio);
      setShowDuplicateLetter(true);
    },
    [],
  );

  const convertStringToDate = (dateString: any) => {
    const [day, month, year] = dateString.split('/').map(Number);
    // Mês no JavaScript começa do zero, então subtraia 1 do mês
    return new Date(year, month - 1, day);
  };

  const customSort = (dateA: any, dateB: any) => {
    if (dateA < dateB) {
      return -1;
    }
    if (dateA > dateB) {
      return 1;
    }
    return 0;
  };

  return (
    <Container>
      <Row className="titleWrapper">
        <Column small="1" medium="1" large="1">
          <IconContainer align="center">
            <MdBlock />
          </IconContainer>
        </Column>
        <Column small="10" medium="10" large="10" className="TitleContainer">
          <div>
            <Title>Cartões bloqueados sem 2ᵃ via</Title>
            {/* <p>
                Donec bibendum metus ac felis tristique mollis. Ut quis orci
                condimentum, faucibus purus in, posuere nunc. Donec bibendum, est
                sit amet auctor tincidunt, nisl purus sodales ligula, ut vehicula
                quam arcu vitae nunc.
              </p> */}
          </div>
        </Column>
      </Row>
      {/* <FiltersContainer>
        <div className="search">
          <Form ref={formRef} onSubmit={handleNumberCardFilter}>
            <Input
              id="search"
              name="search"
              type="text"
              placeholder="Busca por número do cartão"
            />
            <Button
              color="orange"
              padding="1"
              type="submit"
              className="searchButton"
            >
              <MdSearch size={20} />
            </Button>
          </Form>
        </div>
        <div className="buttonsContainer">
          <Button
            color="purple"
            padding="1"
            type="button"
            className="clearFilters"
            onClick={handleClearFilters}
          >
            <MdFilterList />
            LIMPAR FILTROS
          </Button>
        </div>
      </FiltersContainer> */}

      <ButtonsContainer>
        <div className="buttonsInitial">
          <Button
            color="purple"
            padding="1"
            type="button"
            className="csv"
            onClick={() => {
              return titular.AsyncReport === true
                ? openModalCSV()
                : handleReport('csv');
            }}
          >
            <HiDownload />
            GERAR CSV
          </Button>
          <Button
            color="purple"
            padding="1"
            type="button"
            className="pdf"
            onClick={() => {
              return titular.AsyncReport === true
                ? openModalPDF()
                : handleReport('pdf');
            }}
          >
            <HiDownload />
            GERAR PDF
          </Button>
        </div>
      </ButtonsContainer>
      <Row>
        <Column small="2" medium="2" large="2">
          <InfoContainer>
            <InfoItem className="infoitem">
              <span className="info">&#9432;</span>
              <span className="ajuda">
                <p className="text">
                  <strong>Fique atento! </strong>
                  Os cartões bloqueados sem emissão de 2ª via, devem ser pagos
                  para a solicitação de novos cartões. O custo é de R$15,00 por
                  cartão.
                </p>
                <p className="text">
                  <strong>BLOQUEIO CAB: </strong>
                  Bloqueio realizado pela empresa no site
                </p>
                <p className="text">
                  <strong>IRREGULARIDADE NA UTILIZAÇÃO: </strong>
                  Bloqueio automático realizado por uso indevido do cartão
                </p>
              </span>
            </InfoItem>
          </InfoContainer>
        </Column>
        <Column small="10" medium="10" large="10">
          <BloquedTable
            data={bloqued?.ListaDeCartoesBloqSemSegVia}
            columns={[
              {
                name: 'Cartão VT',
                selector: 'CrtCodIdentifExt',
              },
              {
                name: 'Data de Bloqueio',
                selector: 'DataBloqueio',
                sortFunction: (a: any, b: any) =>
                  customSort(
                    convertStringToDate(a.DataBloqueio),
                    convertStringToDate(b.DataBloqueio),
                  ),
                sortable: true,
              },
              {
                name: 'Via',
                selector: 'IdentificadorCartaoVTNovo',
                cell: ({ ViaCartao }: any) => <div>{ViaCartao || '--'}</div>,
              },
              {
                name: 'Tipo Bloqueio',
                selector: 'CodigoPedidoDeSegundaVia',
                cell: ({ TipoBloqueio }: any) => (
                  <div>{TipoBloqueio || '--'}</div>
                ),
              },
              {
                name: 'Ações',
                selector: 'CodigoPedidoDeSegundaVia',
                cell: ({ CrtCodIdentifExt, DataBloqueio }: any) => (
                  <Block>
                    <Button
                      color="transparent"
                      title="Carta de autorização de retirada"
                      padding="0"
                      className="carta"
                      type="button"
                      onClick={() => {
                        handleShowModalDuplicateLetter(
                          CrtCodIdentifExt as any,
                          DataBloqueio as any,
                        );
                      }}
                    >
                      <AiOutlineFileDone
                        size={30}
                        style={{ color: '#3F1159' }}
                      />
                    </Button>
                  </Block>
                ),
              },
            ]}
            loading={loading}
            totalRows={totalRows}
            perPage={perPage}
            onChangePage={handleChangePerPage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
            emptyText="Nenhum Cartão bloqueados sem 2ᵃ via até o momento"
          />
        </Column>
      </Row>
      {showDuplicateLetter && (
        <ModalDuplicateLetter
          cardNumber={cardNumber}
          dataBloqueio={dataBloqueio}
          name={responsible}
          title="Carta de autorização de retirada"
          text={`Cartão ${cardNumber} bloqueado com sucesso em ${
            dataBloqueio.split(' ')[0]
          }.`}
          show={showDuplicateLetter}
          handleClose={() => setShowDuplicateLetter(false)}
          handleSuccess={getTitular}
        />
      )}

      {modalRelatorio && (
        <Modal
          handleClose={() => setModalRelatorio(false)}
          show={modalRelatorio}
          title="Agendamento de Relatório"
        >
          <ModalContent>
            <Form ref={formRefRelatorio} onSubmit={handleSubmitRelatorio}>
              <FormWrapper>
                <p>Estamos processando os dados do pedido do Relatório.</p>
                <p>
                  <LinkModal onClick={relatorio}>Clique Aqui!</LinkModal>
                  Para abrir o menu Relatórios Agendados e acompanhar o Pedido
                  solicitado. Quando este processo for finalizado basta fazer o
                  download do arquivo.
                </p>
              </FormWrapper>
            </Form>
          </ModalContent>
        </Modal>
      )}
      {loadingModal && (
        <LoaderModal
          title="Carregando"
          show={loadingModal}
          handleClose={() => setLoadingModal(false)}
        />
      )}
    </Container>
  );
};

export default BloquedNotDuplicated;
